import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
  Layers,
  Building2,
  Users as UsersIcon,
  Activity,
  Megaphone,
  Link2,
  KeyRound,
  Brain,
  Puzzle,
} from "lucide-react";
import { useDashboardSession } from "../../auth/useDashboardSession.js";

const NAV = [
  { to: "/dashboard/platform/tenants",       label: "全部客戶單位",      icon: Building2 },
  { to: "/dashboard/platform/users",         label: "全部使用者",    icon: UsersIcon },
  { to: "/dashboard/platform/health",        label: "系統狀態",  icon: Activity },
  { to: "/dashboard/platform/announcements", label: "全平台公告",  icon: Megaphone },
  { to: "/dashboard/platform/me/link-line",  label: "綁定我的 LINE", icon: Link2 },
  { to: "/dashboard/platform/secrets",       label: "平台金鑰",      icon: KeyRound },
  { to: "/dashboard/platform/modules",       label: "模組啟用",      icon: Puzzle },
  { to: "/dashboard/platform/shared-skills", label: "共用技能庫",    icon: Brain },
] as const;

export default function PlatformLayout(): React.ReactElement {
  const session = useDashboardSession();
  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between gap-3 rounded-2xl border border-accent/30 bg-bg-surface px-4 py-3 shadow-xl">
        <div className="flex items-center gap-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent/15 text-accent">
            <Layers className="h-4 w-4" strokeWidth={2.25} />
          </span>
          <div>
            <h1 className="text-sm font-semibold text-text-primary">SENTRY 平台管理</h1>
            <p className="text-2xs text-text-muted">跨單位系統檢視與操作。所有變更都以平台管理員身分留下紀錄。</p>
          </div>
        </div>
        <div className="text-2xs font-mono text-text-muted">
          {session.email ?? "—"}
        </div>
      </header>

      <nav className="flex flex-wrap gap-1 rounded-xl bg-bg-surface border border-border p-1">
        {NAV.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end
            className={({ isActive }) =>
              [
                "flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors",
                isActive
                  ? "bg-accent/15 text-accent"
                  : "text-text-secondary hover:bg-bg-base hover:text-text-primary",
              ].join(" ")
            }
          >
            <it.icon className="h-3.5 w-3.5" strokeWidth={2.25} />
            <span>{it.label}</span>
          </NavLink>
        ))}
      </nav>

      <section>
        <Outlet />
      </section>
    </div>
  );
}
